import { find, isNil } from 'lodash';

import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { TrafficSchoolStatus } from '../../types/traffic_school.enum';
import { RelationToUser } from '../../types/driver';

/**
 * Show driverlicense screen when all the following conditions are met:
 * 1. The user is not from onboarding lite
 * 2. The user is from traffic school flow
 * 3. Fail to find the driver’s license state and number from the data pull OR the user driver license state we pulled is not ‘CA’
 */

export const DriverLicenseStep: Step = {
  id: 'driverlicense',
  pathname: '/driverlicense',
  canShow: (appData: AppData) => {
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    if (appData.signupParams?.trafficSchoolStatus !== TrafficSchoolStatus.ENTERED || appData.isOnboardingLite) {
      return false;
    }

    // Get the driver's license number and state we got from the data pull
    const { driverLicenseState, driverLicenseNumberMasked } =
      find(appData.searchPolicyData?.drivers, (driver) => driver.relationToUser === RelationToUser.Insured) || {};
    return !driverLicenseState || !driverLicenseNumberMasked || driverLicenseState !== 'CA';
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    // Verify the state and number of the user's driver's license in the database.
    const { driverLicenseState, driverLicenseNumberMasked } =
      find(appData.drivers, (driver) => driver.relationToUser === RelationToUser.Insured) || {};
    return !isNil(driverLicenseState) && !isNil(driverLicenseNumberMasked);
  },
};
